import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CustomFamiliesAdapter} from './custom-families.adapters';


@Injectable({
  providedIn: 'root',
})
export class CustomFamiliesConnector {
  constructor(protected adapter: CustomFamiliesAdapter) {}

  get(code, professional): Observable<any[]> {
    return this.adapter.load(code, professional);
  }
}
